import { useNavigate } from "react-router-dom";
import { BULK_PHONE_VERIFY, BULK_PHONE_UNVERIFY } from "../../apiEndpoints";
import usePutData from "../../../../CustomHooks/useAxios/usePutData";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

const BulkPhoneVerificationDialog = ({ actionType, userIDs, closeDialog }) => {
  const { executePut, loading, successResponse, formError, setFormError } =
    usePutData();

  const navigate = useNavigate();
  const isVerify = actionType === "Verify";
  const selectedCount = userIDs.length;

  // user Verification API call
  const handlePhoneVerification = () => {
    const apiUrl = isVerify
      ? BULK_PHONE_VERIFY // Verify
      : BULK_PHONE_UNVERIFY; // Un-verify

    executePut(apiUrl, { userIds: userIDs });
  };

  const btnText = isVerify ? "Verify" : "Unverify";
  const loadingText = isVerify ? "Verifying..." : "Unverifying...";
  const btnClass = isVerify
    ? "bg-teal-600 hover:bg-teal-500"
    : "bg-amber-600 hover:bg-amber-500";

  return (
    <Modal
      onClose={successResponse || loading ? undefined : closeDialog}
      modalWidth={`${
        successResponse ? "max-w-sm" : "max-w-lg"
      } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5">
              {isVerify ? "Verified" : "Unverified"} Successfully.
            </p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("false")}
              />
            )}
            <h2 className="text-xl font-figtreeBold mb-4">
              {isVerify ? "Verify" : "Unverify"} Phone Number
            </h2>
            <p className="text-gray-700 mb-6">
              Are you sure you want to {isVerify ? "Verify" : "Unverify"}
              <span className="font-medium text-black">
                {" "}
                {selectedCount > 1 ? `${selectedCount} users` : "this user"}
              </span>
              ? <br />
              {isVerify
                ? "This action will allow OTPs to be sent to the user’s phone number."
                : "This action will stop OTP from being sent to the user’s phone number."}
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={closeDialog}
                className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handlePhoneVerification}
                className={`px-4 py-2 rounded-lg text-white transition-colors ${btnClass}`}
                disabled={loading}
              >
                {loading ? loadingText : btnText}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
};

export default BulkPhoneVerificationDialog;
